import React, { useEffect, useState } from 'react';
import { Box, Typography, Paper } from '@mui/material';
import { useTimezone } from '../contexts/TimezoneContext';
import { formatDateInTimezone, formatRelativeTime, isToday } from '../utils/dateUtils';

interface TimeSample {
  serverTime: string;
  localTime: string;
  isToday: boolean;
  relativeTime: string;
}

export const TimezoneTest: React.FC = () => {
  const { timezone, offset } = useTimezone();
  const [samples, setSamples] = useState<TimeSample[]>([]);

  useEffect(() => {
    // Create sample times
    const now = new Date();
    const yesterday = new Date(now.getTime() - 24 * 60 * 60 * 1000);
    const lastWeek = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);

    const times = [now, yesterday, lastWeek];
    const newSamples = times.map(time => ({
      serverTime: time.toISOString(),
      localTime: formatDateInTimezone(time, timezone),
      isToday: isToday(time, timezone),
      relativeTime: formatRelativeTime(time)
    }));

    setSamples(newSamples);
  }, [timezone]);

  return (
    <Box p={3}>
      <Typography variant="h4" gutterBottom>
        Timezone Test Component
      </Typography>
      
      <Paper sx={{ p: 2, mb: 2 }}>
        <Typography variant="h6" gutterBottom>
          User Timezone Information
        </Typography>
        <Typography>Timezone: {timezone}</Typography>
        <Typography>Offset: {offset} minutes</Typography>
      </Paper>

      <Paper sx={{ p: 2 }}>
        <Typography variant="h6" gutterBottom>
          Time Samples
        </Typography>
        {samples.map((sample, index) => (
          <Box key={index} sx={{ mb: 2 }}>
            <Typography variant="subtitle1" fontWeight="bold">
              Sample {index + 1}
            </Typography>
            <Typography>Server Time: {sample.serverTime}</Typography>
            <Typography>Local Time: {sample.localTime}</Typography>
            <Typography>Is Today: {sample.isToday ? 'Yes' : 'No'}</Typography>
            <Typography>Relative Time: {sample.relativeTime}</Typography>
          </Box>
        ))}
      </Paper>
    </Box>
  );
};
